export const currencies = ["CAD", "GBX", "USD", "EUR", "GBP"];
